import Settings from '@/classes/Settings';
import cloneDeep from 'lodash/cloneDeep';

const defaultSettings = Settings.defaultSettings();

const getSettings = state => {
  return new Settings(cloneDeep(state.settings));
}

const userTheme = state => {
  return state.settings.displayPreferences?.theme || defaultSettings.displayPreferences.theme;
};

const userLocale = state => {
  return state.settings.displayPreferences?.language || defaultSettings.displayPreferences.language;
};

const getUserTimeFormat = state => {
  return state.settings.displayPreferences?.timeFormat || defaultSettings.displayPreferences.timeFormat;
};

const getUserTimeZone = state => {
  return state.settings.displayPreferences?.timeZone || defaultSettings.displayPreferences.timeZone;
};

const currentTab = state => {
  return state.settings.interfaceState?.currentTab || defaultSettings.interfaceState.currentTab;
};

const hasNotificationsEnable = state => {
  return state.settings.additionalOptions?.enableNotifications;
};

const incomingNotificationSounds = state => {
  return state.incomingNotificationSounds;
};

const selectedIncomingNotificationSound = state => {
  return state.incomingNotificationSounds.find(
    notificationSound => notificationSound.value === state.selectedIncomingNotificationSound.value
  ) || {};
};

const getFavoriteContacts = state => {
  return state.settings.interfaceState.favoriteContacts || [];
};

export default {
  currentTab,
  userTheme,
  userLocale,
  getUserTimeFormat,
  getUserTimeZone,
  hasNotificationsEnable,
  incomingNotificationSounds,
  selectedIncomingNotificationSound,
  getSettings,
  getFavoriteContacts
};
